module.exports = __webpack_public_path__ + "img/menu-item-2.cb571f43.svg";